import React, { useEffect, useState } from 'react'

function CreateAgenziaForm({formCreateAgenzia, setFormCreateAgenzia, showModalCreateAgenzia}) {

    useEffect(() => {
        if(!showModalCreateAgenzia) {
            setFormCreateAgenzia({});
        }
    }, [showModalCreateAgenzia])

    const handleFormChange = e => {
        const { name, value } = e.target;
        setFormCreateAgenzia(prevState => ({ ...prevState, [name]: value }));
    }

  return (
    <div className='container'>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Ragione sociale</b></span>
               <input name="denominazione" value={formCreateAgenzia.denominazione || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Ragione sociale"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <input name="indirizzo" value={formCreateAgenzia.indirizzo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>CAP</b></span>
               <input name="cap" value={formCreateAgenzia.cap || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="CAP"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Città</b></span>
               <input name="citta" value={formCreateAgenzia.citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
               <input name="provincia" value={formCreateAgenzia.provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Partita iva</b></span>
               <input name="piva" value={formCreateAgenzia.piva || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Partita iva"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Referente</b></span>
               <input name="referente" value={formCreateAgenzia.referente || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Referente"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Email</b></span>
               <input name="email" value={formCreateAgenzia.email || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Note</b></span>
               <textarea name="note" value={formCreateAgenzia.note || ''} onChange={handleFormChange} className="form-control" rows={3} type="text" placeholder="Note"/>
            </div>
        </div>
    </div>
  )
}

export default CreateAgenziaForm;